"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetUploadIcon16Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.NetUploadIcon16Solid = forwardRef_1.forwardRef('NetUploadIcon16Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { d: "M6.75 3.527v6.098a1.25 1.25 0 1 0 2.5 0V3.527l2.42 2.15a1.25 1.25 0 0 0 1.66-1.868L9.827.695A2.744 2.744 0 0 0 7.992 0c-.65.002-1.3.233-1.819.695L2.67 3.809a1.25 1.25 0 1 0 1.66 1.868l2.42-2.15Z" }),
        react_1.default.createElement("path", { d: "M1.25 13.5c0-.69.56-1.25 1.25-1.25h11a1.25 1.25 0 1 1 0 2.5h-11c-.69 0-1.25-.56-1.25-1.25Z" })));
});
